import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ComponentBase, LocationInfo, AuthService } from 't4core';
import { ServiceGuyInfo } from '../../../../projects/t4core/src/public-api';


@Component({
    selector: 't4-locationInfo',
    templateUrl: './locationInfo.component.html',
    styleUrls: ['./locationInfo.component.css'],
})
export class LocationInfoComponent extends ComponentBase implements OnInit {
    @Input() locationId: number;
    @Input() location: LocationInfo = new LocationInfo();

    @ViewChild('gmap', {static: true}) gmapElement: ElementRef;

    private map: google.maps.Map;
    private pin: google.maps.Marker;
    public serviceGuy: ServiceGuyInfo; 

    constructor(private authService: AuthService) {
        super();
    }

    async ngOnInit() {
        var pos = new google.maps.LatLng(0, 0);
        if (this.location && this.location.Id > 0) {
            pos = new google.maps.LatLng(this.location.Latitude, this.location.Longitude);
        } else if (this.locationId) {
            this.location = await this.Api.get<LocationInfo>("Location/GetLocationInfo", { id: this.locationId });
            pos = new google.maps.LatLng(this.location.Latitude, this.location.Longitude);
        }

      if (this.location) {
        this.getServiceGuy(this.location.Id);
      }

        this.gmapElement.nativeElement.src = "https://maps.googleapis.com/maps/api/staticmap?center=" + pos.lat() + "," + pos.lng() + "&zoom=10&size=338x250&maptype=roadmap&markers=" + pos.lat() + "," + pos.lng() + "&key=AIzaSyAPITA4UuI9ERN_XiTDXZC1packZFkx-xE";
    }

    async ngOnChanges(changes: SimpleChanges) {  
        var pos = new google.maps.LatLng(0, 0);
        if (this.location &&    this.location.Id > 0) {
            pos = new google.maps.LatLng(this.location.Latitude, this.location.Longitude);
        } else if (this.locationId) {
            this.location = await this.Api.get<LocationInfo>("Location/GetLocationInfo", { id: this.locationId });
            pos = new google.maps.LatLng(this.location.Latitude, this.location.Longitude);
      }
      if (this.location) {
        this.getServiceGuy(this.location.Id);
      }

        this.gmapElement.nativeElement.src = "https://maps.googleapis.com/maps/api/staticmap?center=" + pos.lat() + "," + pos.lng() + "&zoom=10&size=338x250&maptype=roadmap&markers=" + pos.lat() + "," + pos.lng() + "&key=AIzaSyAPITA4UuI9ERN_XiTDXZC1packZFkx-xE";
  }

  private async getServiceGuy(pos: number) {
    this.serviceGuy = await this.Api.get<ServiceGuyInfo>("Service/GetLocationServiceGuy", { locationId: pos });
  }

  public async impersonate() {
    if (!this.location) return;
    var ret = await this.UI.confirm("Turbo.LocationInfo.promptComfirmImpersonate", "Confirm impersonate location", "Turbo.LocationInfo.promptComfirmImpersonateMsg", "Do you want to impersonate the location - {0}?", null, [this.location.Name]);
    if (ret) {
      this.authService.impersonate(this.location.LocationCode + "_Admin").then(x => {
      });
    }
    else return;
  }
}
